import React from "react";
import { styled } from "@glitz/react";
import { black, white, fontWeight, green } from "../../theme";

const Wrapper = styled.label({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  cursor: "pointer",
  fontWeight: fontWeight.bold,
});

const HiddenCheckbox = styled.input({
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
});

const Box = styled.span({
  width: "18px",
  height: "18px",
  minWidth: "18px",
  borderRadius: "4px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: { xy: { style: "solid", width: "1px", color: black } },
  backgroundColor: white,
  transitionProperty: "all",
  transitionDuration: "0.2s",
  transitionTimingFunction: "ease",
});

type CheckboxProps = {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  color?: string;
};

const Checkbox: React.FC<CheckboxProps> = ({
  label,
  checked,
  onChange,
  color = green,
}) => {
  const afterStyle = checked
    ? {
        "::after": {
          content: '"✓"',
          color: white,
          fontSize: "12px",
          fontWeight: fontWeight.bold,
        },
      }
    : {};

  return (
    <Wrapper>
      <HiddenCheckbox
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Box
        css={{
          border: {
            xy: {
              style: "solid",
              width: "1px",
              color: checked ? color : black,
            },
          },
          backgroundColor: checked ? color : white,
          ...afterStyle,
        }}
      />
      {label}
    </Wrapper>
  );
};

export default Checkbox;
